import { useEffect } from "react";
import { useLocation, useParams } from "react-router";
import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";
import { useClientPortalNavigate } from "../../../hooks/useClientPortalRouter";
import { ROUTES } from "../../../routes";
import { useTokenValidation } from "./hooks/useTokenValidation";
import LoadingOverlay from "../../Shared/LoadingOverlay";

export default function ResetPassword() {
    const location = useLocation();
    const navigateTo = useClientPortalNavigate();
    const { validateToken, isPending } = useTokenValidation();
    const { token } = useParams();

    useEffect(() => {
        if (!token) {
            enqueueSnackbar("The link you are accessing is invalid. Please contact the clinic for assistance.", {
                variant: "error",
                alertTitle: "Error",
            });
            navigateTo(ROUTES.HOME.urlPath);
        } else {
            void validateToken(token);
        }
    }, [token, location.pathname, navigateTo, validateToken]);

    return isPending ? <LoadingOverlay /> : <></>;
}
